"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadExternalApi = exports.LeadExternalApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
// @ts-ignore
const models_2 = require("../models");
/**
 * LeadExternalApi - axios parameter creator
 * @export
 */
const LeadExternalApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {{ [key: string]: any; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAquagroupSite: async (requestBody, options = {}) => {
            // verify required parameter 'requestBody' is not null or undefined
            (0, common_1.assertParamExists)('createAquagroupSite', 'requestBody', requestBody);
            const localVarPath = `/api/lead/aquagroup-site`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {BobexLeadBody} bobexLeadBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBobexLead: async (bobexLeadBody, options = {}) => {
            // verify required parameter 'bobexLeadBody' is not null or undefined
            (0, common_1.assertParamExists)('createBobexLead', 'bobexLeadBody', bobexLeadBody);
            const localVarPath = `/api/lead/bobex`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bobexLeadBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SolvariLeadBody} solvariLeadBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSolvariLead: async (solvariLeadBody, options = {}) => {
            // verify required parameter 'solvariLeadBody' is not null or undefined
            (0, common_1.assertParamExists)('createSolvariLead', 'solvariLeadBody', solvariLeadBody);
            const localVarPath = `/api/solvari/lead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(solvariLeadBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.LeadExternalApiAxiosParamCreator = LeadExternalApiAxiosParamCreator;
/**
 * LeadExternalApi -
 */
var LeadExternalApi;
(function (LeadExternalApi) {
    /**
     *
     * @param {{ [key: string]: any; }} requestBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof LeadExternalApi
     * url /api/lead/aquagroup-site
     */
    async function createAquagroupSite(requestBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.LeadExternalApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createAquagroupSite(requestBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_2.parseInlineResponse2009)(res.data);
            return res;
        });
    }
    LeadExternalApi.createAquagroupSite = createAquagroupSite;
    /**
     *
     * @param {BobexLeadBody} bobexLeadBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof LeadExternalApi
     * url /api/lead/bobex
     */
    async function createBobexLead(bobexLeadBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.LeadExternalApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createBobexLead(bobexLeadBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseInlineResponse2008)(res.data);
            return res;
        });
    }
    LeadExternalApi.createBobexLead = createBobexLead;
    /**
     *
     * @param {SolvariLeadBody} solvariLeadBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof LeadExternalApi
     * url /api/solvari/lead
     */
    async function createSolvariLead(solvariLeadBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.LeadExternalApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createSolvariLead(solvariLeadBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseInlineResponse2008)(res.data);
            return res;
        });
    }
    LeadExternalApi.createSolvariLead = createSolvariLead;
})(LeadExternalApi || (exports.LeadExternalApi = LeadExternalApi = {}));
